var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490.29 490.29",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.343,
    y: -62.678,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 591.6399 245.173)",
    width: 77.399,
    height: 615.594
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.144,
    y: 335.976,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -231.1054 191.4143)",
    width: 249.298,
    height: 77.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.136,
    y: 77.228,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 721.7715 -67.1118)",
    width: 249.298,
    height: 77.399
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.77527bbd4e792c3b4e7ab09f78033a32.svg";
export { ForwardRef as ReactComponent };